import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { toast } from 'react-toastify';

const Footer = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [config, setConfig] = useState({ socialLinks: {}, businessHours: [], phones: [], emails: [], officeAddress: '' });
  const [visitorCount, setVisitorCount] = useState(0);
  const hasTracked = useRef(false);

  // Fetch contact info, social links, and business hours from top utility config
  useEffect(() => {
    const fetchSocialLinks = async () => {
      try {
        const response = await axios.get('/api/top-utility/config');
        if (response.data.success) {
          setConfig({
            socialLinks: response.data.data.socialLinks || {},
            businessHours: response.data.data.businessHours || [],
            phones: response.data.data.phones || [],
            emails: response.data.data.emails || [],
            officeAddress: response.data.data.officeAddress || ''
          });
        }
      } catch (error) {
        console.error('Error fetching social links:', error);
      }
    };

    fetchSocialLinks();
  }, []);

  // Track visitor and fetch total count
  useEffect(() => {
    const trackVisitor = async () => {
      try {
        // Check if visitor was already counted in this session
        const hasVisited = sessionStorage.getItem('visitor_counted');
        
        if (!hasVisited && !hasTracked.current) {
          hasTracked.current = true;
          // Increment visitor count
          await axios.post('/api/visitor-count/increment');
          sessionStorage.setItem('visitor_counted', 'true');
        }

        // Fetch total visitor count
        const response = await axios.get('/api/visitor-count/total');
        if (response.data.success) {
          setVisitorCount(response.data.data.totalCount);
        }
      } catch (error) {
        console.error('Error tracking visitor:', error);
      }
    };

    trackVisitor();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm({
    mode: 'onBlur'
  });

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await axios.post('/api/contact/submit', data);

      if (response.data.success) {
        setSubmitStatus('success');
        toast.success('Contact form submitted successfully!');
        reset();
      } else {
        setSubmitStatus('error');
        toast.error(response.data.message || 'Failed to submit form');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
      const errorMessage = error.response?.data?.message || 'An error occurred. Please try again.';
      toast.error(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="industify_fn_footer">
      <div className="top_footer">
        <div className="top_footer_img" style={{ position: 'relative', zIndex: 1 }} data-fn-bg-img="img/footer/bg.jpg"></div>

        {/* CONTACT FORM SECTION */}


        {/* SUBSCRIBE */}
        {/* <div className="subscribe_f">
          <div className="container">
            <div className="subscribe_in">
              <div className="s_left">
                <img className="fn__svg" src="svg/open-book.svg" alt="svg" />
                <p>Newsletter — get updates with latest topics</p>
              </div>
              <div className="s_right">
                <div className="subscriber">
                  <input type="email" placeholder="Your e-mail address *" />
                  <input type="submit" value="Subscribe" />
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* /SUBSCRIBE */}

        {/* TRIPLE WIDGET */}
        <div className="footer_widget">
          <div className="container">
            <div className="inner">
              <ul className="widget_area">
                <li>
                  <div className="item">
                    <div className="logo" >
                      <Link to="/"><img src="/img/AID-footer.svg" alt="" style={{height:"120px"}}/></Link>
                      <div className="textwidget">
                        <div style={{ marginTop: '20px' }}>
                          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'center' }}>
                            {config.socialLinks?.facebook && (
                              <a 
                                href={config.socialLinks.facebook} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{
                                  width: '40px',
                                  height: '40px',
                                  backgroundColor: 'transparent',
                                  border: '1px solid #fff',
                                  borderRadius: '8px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#672f89';
                                  e.currentTarget.style.borderColor = '#672f89';
                                  e.currentTarget.querySelector('svg').style.color = '#fff';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent';
                                  e.currentTarget.style.borderColor = '#fff';
                                  e.currentTarget.querySelector('svg').style.color = '#fff';
                                }}
                              >
                                <svg style={{ width: '20px', height: '20px', color: '#fff', transition: 'color 0.3s ease' }} fill="currentColor" viewBox="0 0 24 24">
                                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                                </svg>
                              </a>
                            )}
                            {config.socialLinks?.twitter && (
                              <a 
                                href={config.socialLinks.twitter} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{
                                  width: '40px',
                                  height: '40px',
                                  backgroundColor: 'transparent',
                                  border: '1px solid #fff',
                                  borderRadius: '8px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#672f89';
                                  e.currentTarget.style.borderColor = '#672f89';
                                  e.currentTarget.querySelector('svg').style.color = '#fff';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent';
                                  e.currentTarget.style.borderColor = '#fff';
                                  e.currentTarget.querySelector('svg').style.color = '#fff';
                                }}
                              >
                                <svg style={{ width: '20px', height: '20px', color: '#fff', transition: 'color 0.3s ease' }} fill="currentColor" viewBox="0 0 24 24">
                                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                                </svg>
                              </a>
                            )}
                            {config.socialLinks?.linkedin && (
                              <a 
                                href={config.socialLinks.linkedin} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{
                                  width: '40px',
                                  height: '40px',
                                  backgroundColor: 'transparent',
                                  border: '1px solid #fff',
                                  borderRadius: '8px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#672f89';
                                  e.currentTarget.style.borderColor = '#672f89';
                                  e.currentTarget.querySelector('svg').style.color = '#fff';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent';
                                  e.currentTarget.style.borderColor = '#fff';
                                  e.currentTarget.querySelector('svg').style.color = '#fff';
                                }}
                              >
                                <svg style={{ width: '20px', height: '20px', color: '#fff', transition: 'color 0.3s ease' }} fill="currentColor" viewBox="0 0 24 24">
                                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                                </svg>
                              </a>
                            )}
                            {config.socialLinks?.instagram && (
                              <a 
                                href={config.socialLinks.instagram} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{
                                  width: '40px',
                                  height: '40px',
                                  backgroundColor: 'transparent',
                                  border: '1px solid #fff',
                                  borderRadius: '8px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#672f89';
                                  e.currentTarget.style.borderColor = '#672f89';
                                  e.currentTarget.querySelector('svg').style.color = '#fff';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent';
                                  e.currentTarget.style.borderColor = '#fff';
                                  e.currentTarget.querySelector('svg').style.color = '#fff';
                                }}
                              >
                                <svg style={{ width: '20px', height: '20px', color: '#fff', transition: 'color 0.3s ease' }} fill="currentColor" viewBox="0 0 24 24">
                                  <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
                                </svg>
                              </a>
                            )}
                            {config.socialLinks?.youtube && (
                              <a 
                                href={config.socialLinks.youtube} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{
                                  width: '40px',
                                  height: '40px',
                                  backgroundColor: 'transparent',
                                  border: '1px solid #fff',
                                  borderRadius: '8px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#672f89';
                                  e.currentTarget.style.borderColor = '#672f89';
                                  e.currentTarget.querySelector('svg').style.color = '#fff';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent';
                                  e.currentTarget.style.borderColor = '#fff';
                                  e.currentTarget.querySelector('svg').style.color = '#fff';
                                }}
                              >
                                <svg style={{ width: '20px', height: '20px', color: '#fff', transition: 'color 0.3s ease' }} fill="currentColor" viewBox="0 0 24 24">
                                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                                </svg>
                              </a>
                            )}
                          </div>
                        </div>
                    </div>
                    </div>
                  
                  </div>
                </li>
                <li>
                  <div className="item" style={{ textAlign: "left", paddingTop: "20px" }}>
                    <div
                      style={{
                        fontSize: "20px",
                        fontWeight: "600",
                        marginBottom: "12px",
                        position: "relative",
                        display: "inline-block",
                        color: "#eee",
                      }}
                    >
                      Business Hours
                      <div
                        style={{
                          height: "2px",
                          width: "40px",
                          backgroundColor: "#c57cff",
                          marginTop: "6px",
                        }}
                      ></div>
                    </div>
                    <div className="industify_fn_widget_business_hours">
                      <div>
                        <ul>
                          {(config.businessHours && config.businessHours.length > 0
                            ? config.businessHours
                            : [
                                { day: 'Monday-Friday', hours: '9am to 5pm' },
                                { day: 'Saturday', hours: '10am to 3pm' },
                                { day: 'Sunday', hours: 'Closed' }
                              ]
                          ).map((entry, index) => (
                            <li key={index}>
                              <div className="day_item">
                                <span className="day">{entry.day}:</span>
                                <span className="hours">{entry.hours}</span>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    
                    {/* Visitor Counter */}
                    <div style={{ marginTop: "120px" }}>
                      <div
                        style={{
                          fontSize: "15px",
                          fontWeight: "600",
                          marginBottom: "12px",
                          position: "relative",
                          display: "inline-block",
                          color: "#eee",
                        }}
                      >
                        Visitor Counter
                        {/* <div
                          style={{
                            height: "2px",
                            width: "40px",
                            backgroundColor: "#c57cff",
                            marginTop: "6px",
                          }}
                        ></div> */}
                      </div>
                      <div style={{ 
                        display: "flex",
                        gap: "8px",
                        alignItems: "center",
                      }}>
                        {visitorCount.toString().split('').map((digit, index) => (
                          <div 
                            key={index}
                            style={{
                              width: '25px',
                              height: '30px',
                              border: '1px solid #fff',
                              borderRadius: '4px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '16px',
                              fontWeight: '400',
                              color: '#fff',
                              fontFamily: 'monospace',
                              backgroundColor: 'transparent'
                            }}
                          >
                            {digit}
                          </div>
                        ))}
                      </div>
                      <div style={{ 
                        fontSize: "14px", 
                        color: "#aaa",
                        marginTop: "5px"
                      }}>
                        {/* Total Visits */}
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div
                    style={{
                      textAlign: "left",
                      color: "#eee",
                      padding: "20px 10px",
                      lineHeight: "22px",
                      fontSize: "15px",
                      maxWidth: "380px",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "20px",
                        fontWeight: "600",
                        marginBottom: "12px",
                        position: "relative",
                        display: "inline-block",
                      }}
                    >
                      Contact
                      <div
                        style={{
                          height: "2px",
                          width: "40px",
                          backgroundColor: "#c57cff",
                          marginTop: "6px",
                        }}
                      ></div>
                    </div>

                    <ul style={{ listStyle: "none", padding: 0, margin: "8px 0 0 0" }}>
                      {config.emails && config.emails.length > 0 && (
                        <li style={{ marginBottom: "12px" }}>
                          {config.emails.join(' | ')}
                        </li>
                      )}

                      {config.phones && config.phones.length > 0 && (
                        <li style={{ marginBottom: "12px" }}>
                          {config.phones.join('  |  ')}
                        </li>
                      )}

                      {config.officeAddress && (
                        <li style={{ marginBottom: "12px", whiteSpace: "pre-line" }}>
                          {config.officeAddress}
                        </li>
                      )}
                    </ul>
                  </div>



                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* /TRIPLE WIDGET */}
      </div>

      {/* BOTTOM */}
      <div className="footer_bottom">
        <div className="container">
          <div className="footer_bottom_in">
            <div className="bottom_widget">
              <div className="widget_nav_menu">
                <ul className="menu">
                  {/* <li><Link to="/services">Policy</Link></li> */}
                  {/* <li><Link to="/affiliates">Affiliates</Link></li> */}
                  <li><Link to="/">Disclaimer</Link></li>
                  <li><Link to="/">Privacy Policy</Link></li>
                  {/* <li><Link to="/career">Career</Link></li> */}
                </ul>
              </div>
            </div>
            <div className="footer_copyright">
              <p>&copy; All rights reserved by AID. Designed and Developed by <a href="https://bharat-online.com/" target="_blank" rel="noopener noreferrer" style={{ display: "inline-flex", alignItems: "center", gap: "6px", verticalAlign: "middle" }}><img src="/img/bol.png" alt="Bharat Online" style={{ height: "20px", display: "inline-block" }} />Bharat Online</a></p>
            </div>
            <Link className="industify_fn_totop" to="#">
              <span className="top"></span>
              <span className="text">To Top</span>
            </Link>
          </div>
        </div>
      </div>
      {/* /BOTTOM */}
    </footer>
  );
};

export default Footer;